import api from ".";

export default async function getUsersByApartment(apartmentId: number) {
  const response = await api.get(`/user/apartment/${apartmentId}`);

  return response.data;
}
